import { render, staticRenderFns } from "./PendenteComponent.vue?vue&type=template&id=63ab8d2a&scoped=true"
import script from "./PendenteComponent.vue?vue&type=script&lang=js"
export * from "./PendenteComponent.vue?vue&type=script&lang=js"
import style0 from "./PendenteComponent.vue?vue&type=style&index=0&id=63ab8d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab8d2a",
  null
  
)

export default component.exports